import Controller from '@ember/controller';
import type { AppServicesWaldenVasModel } from 'walden-fast/routes/app/services/walden-vas';
import { SERVICE_NAMES } from 'walden-fast/utils/constants/services';

export default class AppServicesWaldenVasController extends Controller {
  declare model: AppServicesWaldenVasModel;

  serviceName = SERVICE_NAMES.WALDEN_VAS;
}
